<template>
  <v-app>
      <div style="margin-top:120px">
          <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r a v e l  &nbsp;&nbsp;a n d  &nbsp;&nbsp;e a t  &nbsp;&nbsp;l i k e  &nbsp;&nbsp;a  &nbsp;&nbsp;l o c a l
       </p>
       <h2 style="text-align:center;margin-top:-15px">
         Top Most Trending International Destinations
       </h2>
      <v-container>
       <v-layout row wrap>
           <v-flex xs12 sm12 md2 v-for="des in destionation" :key="des.id">
               <v-card :style="{backgroundImage: `url(${des.src})`}" class="tourtheme hvr" @click="despkg(des)">
                <h2 class="themecap">{{des.name}}</h2>
               </v-card>
           </v-flex>
       </v-layout>
       </v-container>
      </div>
    
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      
      destionation: [],
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Destinations1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.destionation = res.data.international;
          console.log(this.destionation);
          
          this.$Progress.finish();
          this.getData();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
    },
    despkg(des) {
     this.$router.push("/destinationPackage/" + des.id);
   }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.hvr:hover {
  cursor: pointer;
  height: 200px;
  /* border : 3px solid; */
  /* border-color: black; */
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
</style>